import { getScoreCategory, getScoreCategoryLabel, ThankYouScreen } from '../views'

type ThankYouPageTabsProps = {
	screens: ThankYouScreen[]
	selectedIndex: number
	onSelectIndex: (index: number) => void
	isLoading: boolean
}

export function ThankYouPageTabs({
	screens,
	selectedIndex,
	onSelectIndex,
	isLoading,
}: ThankYouPageTabsProps) {
	if (isLoading) {
		return (
			<div className="flex gap-2 mb-4">
				{[1, 2, 3].map((i) => (
					<div
						key={i}
						className="h-8 w-32 bg-grey-200 rounded animate-pulse"
					/>
				))}
			</div>
		)
	}

	if (screens.length === 0) {
		return null
	}

	return (
		<div className="flex flex-wrap justify-between gap-2 mb-4">
			{screens.map((screen, index) => (
				<ThankYouPageTab
					key={screen.id}
					screen={screen}
					isSelected={index === selectedIndex}
					onClick={() => onSelectIndex(index)}
				/>
			))}
		</div>
	)
}

type ThankYouPageTabProps = {
	screen: ThankYouScreen
	isSelected: boolean
	onClick: () => void
}

function ThankYouPageTab({ screen, isSelected, onClick }: ThankYouPageTabProps) {
	const category = getScoreCategory(screen.min_score_range)
	const label = getScoreCategoryLabel(category)

	const categoryColors = {
		excellent: {
			bg: isSelected ? 'bg-green-100' : 'bg-grey-50',
			border: isSelected ? 'border-green-500' : 'border-grey-200',
			text: isSelected ? 'text-green-700' : 'text-grey-600',
		},
		good: {
			bg: isSelected ? 'bg-blue-100' : 'bg-grey-50',
			border: isSelected ? 'border-blue-500' : 'border-grey-200',
			text: isSelected ? 'text-blue-700' : 'text-grey-600',
		},
		noMatch: {
			bg: isSelected ? 'bg-orange-100' : 'bg-grey-50',
			border: isSelected ? 'border-orange-500' : 'border-grey-200',
			text: isSelected ? 'text-orange-700' : 'text-grey-600',
		},
	}

	const colors = categoryColors[category]

	return (
		<button
			type="button"
			onClick={onClick}
			className={`
				px-3 py-1.5 rounded-md text-sm font-medium
				border-2 transition-all cursor-pointer
				${colors.bg} ${colors.border} ${colors.text}
				hover:opacity-80
			`}
		>
			{label}
		</button>
	)
}
